// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard {
    padding: 10px;
    height: 100vh;
    overflow: scroll;
}

.filters {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    justify-content: center;
}

.filter-item {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.select-box, .date-input {
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 5px;
}

.search-button {
    background-color: var(--primary-color);
    color: white;
    font-weight: bold;
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    margin-top: 10px;
    height: 40px;
}

.search-button:hover {
    background-color: var(--primary-color);
}

.card-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 20px;
}

.card {
    display: flex;
    flex-direction: column;
    border: 1px solid black;
    border-radius: 5px;
    width: 300px;
    background-color: bisque;
    padding: 10px;
}



.card-data {
    display: flex;
    gap: 10px;
}

.card-value {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 120px;
    height: 40px;
    border-left: 1px solid #ddd;
    border-right: 1px solid #ddd;
}

.value-text {
    font-size: 16px;
    font-weight: bold;
    color: black;
}

.date-text {
    font-size: 12px;
}

.error-message {
    color: red;
    font-size: 14px;
}



.card-container {
    border: 1px solid black;
    height: 40px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    background-color: bisque;
}

.card-header {
    display: flex;
    justify-content: space-between;
}

.card-title {
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: left;
    font-weight: bold;
    margin-left: 5px;
}

.card-content {
    display: flex;
}

.card-item {
    border-left: 1px solid;
    border-right: 1px solid;
    background-color: var(--primary-color);
    width: 110px;
    height: 100%;
    display: flex;
    justify-content: center;
}

.card-item-text {
    display: flex;
    align-items: center;
    text-align: center;
    color: black;
    margin: 2px;
}

.card-item-text.small-text {
    font-size: 12px;
}

.card-item-text.default-text {
    font-size: 14px;
}
.table-scrollable {
    overflow-y: scroll;
    padding: 20px;
    flex: 1 1; /* makes it take remaining height */
  }

  .tab-navigation {
    display: flex;
    gap: 10px;
    margin-bottom: 16px;
  }
  
  .tab-button {
    padding: 8px 16px;
    background-color: #f0f0f0;
    border: none;
    cursor: pointer;
    border-radius: 6px;
  }
  
  .tab-button.active {
    background-color: var(--primary-color);
    color: white;
    font-weight: bold;
  }`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/dashboard.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,sCAAsC;IACtC,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,wBAAwB;IACxB,aAAa;AACjB;;;;AAIA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,eAAe;AACnB;;;;AAIA;IACI,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,sCAAsC;IACtC,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,SAAO,EAAE,mCAAmC;EAC9C;;EAEA;IACE,aAAa;IACb,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,sCAAsC;IACtC,YAAY;IACZ,iBAAiB;EACnB","sourcesContent":[".dashboard {\n    padding: 10px;\n    height: 100vh;\n    overflow: scroll;\n}\n\n.filters {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 20px;\n    justify-content: center;\n}\n\n.filter-item {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.select-box, .date-input {\n    padding: 8px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n}\n\n.search-button {\n    background-color: var(--primary-color);\n    color: white;\n    font-weight: bold;\n    padding: 10px 20px;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    margin-top: 10px;\n    height: 40px;\n}\n\n.search-button:hover {\n    background-color: var(--primary-color);\n}\n\n.card-list {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    margin-top: 20px;\n}\n\n.card {\n    display: flex;\n    flex-direction: column;\n    border: 1px solid black;\n    border-radius: 5px;\n    width: 300px;\n    background-color: bisque;\n    padding: 10px;\n}\n\n\n\n.card-data {\n    display: flex;\n    gap: 10px;\n}\n\n.card-value {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 120px;\n    height: 40px;\n    border-left: 1px solid #ddd;\n    border-right: 1px solid #ddd;\n}\n\n.value-text {\n    font-size: 16px;\n    font-weight: bold;\n    color: black;\n}\n\n.date-text {\n    font-size: 12px;\n}\n\n.error-message {\n    color: red;\n    font-size: 14px;\n}\n\n\n\n.card-container {\n    border: 1px solid black;\n    height: 40px;\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    background-color: bisque;\n}\n\n.card-header {\n    display: flex;\n    justify-content: space-between;\n}\n\n.card-title {\n    font-size: 14px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    text-align: left;\n    font-weight: bold;\n    margin-left: 5px;\n}\n\n.card-content {\n    display: flex;\n}\n\n.card-item {\n    border-left: 1px solid;\n    border-right: 1px solid;\n    background-color: var(--primary-color);\n    width: 110px;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n}\n\n.card-item-text {\n    display: flex;\n    align-items: center;\n    text-align: center;\n    color: black;\n    margin: 2px;\n}\n\n.card-item-text.small-text {\n    font-size: 12px;\n}\n\n.card-item-text.default-text {\n    font-size: 14px;\n}\n.table-scrollable {\n    overflow-y: scroll;\n    padding: 20px;\n    flex: 1; /* makes it take remaining height */\n  }\n\n  .tab-navigation {\n    display: flex;\n    gap: 10px;\n    margin-bottom: 16px;\n  }\n  \n  .tab-button {\n    padding: 8px 16px;\n    background-color: #f0f0f0;\n    border: none;\n    cursor: pointer;\n    border-radius: 6px;\n  }\n  \n  .tab-button.active {\n    background-color: var(--primary-color);\n    color: white;\n    font-weight: bold;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
